import React, { PropTypes } from 'react';
import cleanHtml from 'utils/janitor';

class Header extends React.Component {
    render () {
        var self = this,
            title = self.props.title || '';

        return (
            <header className="map-header">
                <h1 dangerouslySetInnerHTML={ { __html: cleanHtml(title) } } />
            </header>
        );
    }
};

export default Header;


// WEBPACK FOOTER //
// ./src/app/components/mapHeader/mapHeader.jsx